import { MapHeader } from 'header'

export function MapNav() {
  return <MapHeader menu={false} />
}
